




















































































import Answer from "@/app/models/Answer";
import Question from "@/app/models/Question";
import { Component, Emit, Model, Prop, Vue } from "vue-property-decorator";
import CameraSvg from '../../assets/svg/camera.svg';
import RequiredSvg from '../../assets/svg/required.svg';
import CrossSvg from '../../assets/svg/cross.svg';

@Component({
    components: {
        'camera-svg'  : CameraSvg,
        'required-svg': RequiredSvg,
        'cross-svg'   : CrossSvg,
    }
})
export default class QuestionButtons extends Vue {
    @Model('change', { default: null, type: [Answer, Object] }) readonly answer!: Answer | null;

    @Prop({ type: [Question, Object], required: true }) readonly question!: Question;

    previewImage: string|ArrayBuffer|null = null;

    beforeMount() {
        if (this.answer && this.answer.image_url) {
            this.previewImage = this.answer.image_url;
        }
    }

    get name(): string {
        return `question_${this.question.id}`;
    }

    get mainQuestion(): string {
        return this.makeLinksHtml(this.question.question);
    }

    get subtitle(): string {
        return this.makeLinksHtml(this.question.subtitle || '');
    }

    makeLinksHtml(text: string): string {
        return text.replace(
            /(https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&\/=]*))/gm,
            `<a href="$1">$1</a>`
        );
    }

    changedImage($event: Event) {
        const imageInput = $event.target as HTMLInputElement;

        this.previewImage = null;
        if (imageInput.files!.length === 0) {
            this.emitImageChanged(null);
            return;
        }

        const reader = new FileReader();

        reader.onload = (e: ProgressEvent) => {
            if (e.target !== null) {
                const target = e.target as FileReader;

                this.previewImage = target.result;
                this.emitImageChanged(target.result);
            }
        };

        reader.readAsDataURL(imageInput.files![0]);
    }

    @Emit('change')
    emitImageChanged(image: string|null|ArrayBuffer) {
        if (!this.answer) {
            return new Answer('', image as string, '', null);
        }
        // New upload or delete replaces any previously saved image_url
        return new Answer(this.answer.value, image as string, this.answer.explanation, null);
    }

    @Emit('change')
    onValueChanged(event: Event): Answer {
        const target: HTMLInputElement = event.target! as HTMLInputElement; 

        if (!this.answer) {
            return new Answer(target.value, '', '', null);
        }
        return new Answer(
            target.value,
            this.answer.image as string,
            this.answer.explanation,
            this.answer.image_url,
        );
    }

    deleteImage() {
        this.previewImage = null;
        const input = this.$refs.imageInput as HTMLInputElement | undefined;
        if (input) input.value = '';
        this.emitImageChanged(null);
    }
}
